import React, { useEffect, useState } from 'react';
import { useLogout, useTranslate } from 'ra-core';
import { authProvider } from '../../authProvider';
import { ForgotPasswordConfirm } from './components/ForgotPasswordConfirm';
import { useMutation } from '@tanstack/react-query';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

export const ForgotPasswordPage = () => {
  const logout = useLogout();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [email, setEmail] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const t = useTranslate();
  const { mutate, isPending } = useMutation({
    mutationFn: authProvider.sendPasswordResetLink,
    onSuccess: () => setFormSubmitted(true),
    onError: () => setFormSubmitted(true),
  });

  useEffect(() => {
    void logout(undefined, false);
  }, [logout]);

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const recaptchaAction = 'forgot_password';
    const token = await executeRecaptcha?.(recaptchaAction);
    if (!token) return;
    mutate({ email, token, action: recaptchaAction });
  };

  if (formSubmitted) {
    return <ForgotPasswordConfirm email={email} />;
  }

  return (
    <>
      <div>
        <Link to="/">
          <img
            alt="logo"
            src="https://storage.googleapis.com/public-goloot-production/goloot/goloot-logo-white.png"
            style={{ height: 55, width: 'auto', margin: 'auto' }}
          />
        </Link>
      </div>
      <Card className="shadow-elev-3">
        <CardHeader>
          <CardTitle className="text-xl">
            {t('auth.message.reset_password.header')}
          </CardTitle>
          <CardDescription>
            {t('auth.message.reset_password.message')}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleFormSubmit}>
            <div className="flex flex-col gap-3">
              <Input
                autoComplete="username"
                placeholder={t('auth.label.email')}
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
              <Button type="submit" disabled={isPending}>
                {t('auth.button.send_reset_link')}
              </Button>
              <Link
                to="/login"
                className="text-sm text-center text-muted-foreground underline-offset-4 hover:underline"
              >
                {t('auth.message.reset_password.footer')}
              </Link>
            </div>
          </form>
        </CardContent>
      </Card>
    </>
  );
};

export default ForgotPasswordPage;
